/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";
import { SelectFrequencyComponent } from "../select-frequency/select-frequency.component";

/**
 * Change Frequency Dialog Component
 * Modal dialog for changing the frequency type and value of a scheduled order
 * Matches old QMC ChangeFrequencyDialogComponent
 */
@Component({
  selector: "app-change-frequency-dialog",
  standalone: true,
  imports: [CommonModule, ButtonModule, SelectFrequencyComponent],
  templateUrl: "./change-frequency-dialog.component.html",
  styleUrl: "./change-frequency-dialog.component.scss",
})
export class ChangeFrequencyDialogComponent implements OnInit {
  frequencyType?: string;
  frequency?: number;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    // Initialize with data passed from parent
    if (this.config.data) {
      this.frequency = this.config.data.frequency;
      this.frequencyType = this.config.data.frequencyType;
    }
  }

  /**
   * Handle frequency type selection from select-frequency component
   */
  selectFrequencyType(frequencyType: string): void {
    this.frequencyType = frequencyType;
    this.frequency = undefined;
  }

  /**
   * Handle frequency value selection from select-frequency component
   */
  selectFrequency(frequency: number): void {
    this.frequency = frequency;
  }

  /**
   * Update and close the dialog
   * Only allows update if frequency is valid (not 1 day)
   */
  update(): void {
    // Validation: Don't allow "Every 1 day" frequency
    if (this.frequencyType === "Days" && this.frequency === 1) {
      return;
    }

    // Close dialog with updated values
    this.ref.close({
      frequency: this.frequency,
      frequencyType: this.frequencyType,
    });
  }

  /**
   * Cancel and close the dialog without changes
   */
  cancel(): void {
    this.ref.close(undefined);
  }

  /**
   * Check if update button should be disabled
   */
  isUpdateDisabled(): boolean {
    return !this.frequencyType || this.frequency === undefined;
  }
}
